import { sendRequest } from "../axios";
export default {
  state: {},
  mutations: {},
  actions: {
    getGeo({ commit }, rate_id) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest("api/GeoController/" + rate_id, "get", null, reject).then(
          response => {
            commit("SET_PROCESSING", false);
            resolve(response);
          }
        );
      });
    },
    getGeoForVid({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest("api/getGeoForVid/" + payload.rate_id, "post", payload.formData, reject).then(
          response => {
            commit("SET_PROCESSING", false);
            resolve(response);
          }
        );
      });
    },
    updateGeo({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest("api/updategeo/" + payload.rate_id, "post", payload.formData, reject).then(
          response => {
            commit("SET_PROCESSING", false);
            resolve(response);
          }
        );
      });
    },
    updateComment({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest("api/updategeocomment/" + payload.rate_id, "post", payload.formData, reject).then(
          response => {
            commit("SET_PROCESSING", false);
            resolve(response);
          }
        );
      });
    },
  },
  getters: {}
};
